import { collection, getDocs, query, where, orderBy, limit as fsLimit, getCountFromServer } from 'firebase/firestore';
import { db } from './firestore.js';

// Space docs don't nest Timestamps below the top level, so this only needs
// the flat case of the app's serializeDoc (src/firebase/database.js) — the
// marketing site never reads a space's nested arrays/objects (those only
// carry Timestamps on the authenticated booking side).
function serializeSpace(doc) {
  const data = doc.data();
  const out = { id: doc.id };
  for (const [key, value] of Object.entries(data)) {
    out[key] = value && typeof value.toDate === 'function' ? value.toDate().toISOString() : value;
  }
  return out;
}

// Trimmed mirror of the app's getLiveSpacesPage (src/firebase/database.js) —
// no bookedRanges/listingHolds attachment, since the marketing site's cards
// only ever render formatSpaceMeta/formatSpacePriceLabel fields (see
// ../lib/liveSpaces.js), never availability.
export async function getLiveSpacesPage({ pageSize = 24 } = {}) {
  const snap = await getDocs(
    query(
      collection(db, 'spaces'),
      where('status', '==', 'live'),
      orderBy('createdAt', 'desc'),
      fsLimit(pageSize),
    )
  );
  return { spaces: snap.docs.map(serializeSpace) };
}

// Trimmed mirror of the app's getLiveSpacesByCity, same reasoning.
export async function getLiveSpacesByCity({ city, pageSize = 6 } = {}) {
  if (!city) return { spaces: [] };
  const snap = await getDocs(
    query(
      collection(db, 'spaces'),
      where('status', '==', 'live'),
      where('location.city', '==', city),
      orderBy('createdAt', 'desc'),
      fsLimit(pageSize),
    )
  );
  return { spaces: snap.docs.map(serializeSpace) };
}

// Mirrors the app's getLiveSpacesCityCount.
export async function getLiveSpacesCityCount(city) {
  if (!city) return 0;
  const snap = await getCountFromServer(
    query(collection(db, 'spaces'), where('status', '==', 'live'), where('location.city', '==', city))
  );
  return snap.data().count;
}
